import { useEffect, useState } from "react"
import { SelectOption } from "../../common/types"
import { isError } from "../helpers/Error"
import { Intl } from "../helpers/IntlProps"
import { PAYMENT_TYPE } from "../helpers/Payment"
import { ORIGINAL_METHOD_PAYMENT_TYPE } from "../invoice/Constants"
import PaymentTypeService from "./PaymentTypeService"

export const useGetPaymentTypeOptions = (intl: Intl) => {
    const [loading, setLoading] = useState<boolean>(false)
    const [paymentTypeOptions, setPaymentTypeOptions] = useState<SelectOption<string>[]>([])

    useEffect(() => {
        const fetchPaymentTypes = async () => {
            setLoading(true)
            const paymentTypes = await PaymentTypeService.GetAllPaymentTypes()

            if (!isError(paymentTypes)) {
                setPaymentTypeOptions([
                    {
                        label: intl.formatMessage({
                            id: "invoice.payment_refund_modal.refund_method.original_method",
                            defaultMessage: "Original Method"
                        }),
                        value: ORIGINAL_METHOD_PAYMENT_TYPE
                    },
                    {
                        label: intl.formatMessage({
                            id: "invoice.payment_refund_modal.refund_method.on_account",
                            defaultMessage: "On Account"
                        }),
                        value: PAYMENT_TYPE.CREDIT
                    },
                    {
                        label: intl.formatMessage({
                            id: "invoice.payment_refund_modal.refund_method.credit-card",
                            defaultMessage: "Unprocessed credit card"
                        }),
                        value: PAYMENT_TYPE.CREDIT_CARD
                    },
                    {
                        label: intl.formatMessage({
                            id: "invoice.payment_refund_modal.refund_method.bank-transfer",
                            defaultMessage: "Unprocessed bank transfer"
                        }),
                        value: PAYMENT_TYPE.BANK_TRANSFER
                    },
                    {
                        label: intl.formatMessage({
                            id: "invoice.payment_refund_modal.refund_method.cash",
                            defaultMessage: "Cash"
                        }),
                        value: PAYMENT_TYPE.CASH
                    },
                    {
                        label: intl.formatMessage({
                            id: "invoice.payment_refund_modal.refund_method.check",
                            defaultMessage: "Check"
                        }),
                        value: PAYMENT_TYPE.CHECK
                    },
                    ...paymentTypes.map(type => ({
                        value: type.getId(),
                        label: type.getName(),
                    }))
                ])
            }
            setLoading(false)
        }

        fetchPaymentTypes()
    }, [])

    return { loading, paymentTypeOptions }
}


// WEBPACK FOOTER //
// ./src/state/payment-type/useGetPaymentTypeOptions.ts